import React, { useState } from 'react';
import ReceiptUpload from './ReceiptUpload';
import TransactionDetails from './TransactionDetails';

const TwoStepTransactionForm = ({ onSubmit, isSubmitting, prefillData, onPrefillDataUsed }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [extractedData, setExtractedData] = useState(null);
  const [error, setError] = useState('');

  const handleScanComplete = (scanResult) => {
    setExtractedData(scanResult);
    setCurrentStep(2);
    setError('');
  };

  const handleScanError = (errorMessage) => {
    setError(errorMessage);
  };

  const handleBackToUpload = () => {
    setCurrentStep(1);
    setError('');
  };

  const handleTransactionSubmit = async (transactionData) => {
    try {
      await onSubmit(transactionData);
      // Reset form on successful submission
      setCurrentStep(1);
      setExtractedData(null);
      setError('');
      if (onPrefillDataUsed) {
        onPrefillDataUsed();
      }
    } catch (error) {
      // Error is handled by parent component
      throw error;
    }
  };

  return (
    <div className="max-w-2xl mx-auto">
      {/* Step Indicator */}
      <div className="mb-4">
        <div className="flex items-center justify-center">
          <div className="flex items-center">
            {/* Step 1 */}
            <div className={`flex items-center justify-center w-7 h-7 rounded-full border-2 text-xs font-medium ${
              currentStep === 1
                ? 'border-primary-600 bg-primary-600 text-white'
                : currentStep > 1
                  ? 'border-primary-600 bg-primary-600 text-white'
                  : 'border-gray-300 bg-white text-gray-500'
            }`}>
              1
            </div>
            <span className={`ml-2 text-xs font-medium ${
              currentStep === 1 ? 'text-primary-600' : currentStep > 1 ? 'text-primary-600' : 'text-gray-500'
            }`}>
              Upload Receipt
            </span>

            {/* Connector */}
            <div className={`flex-1 h-0.5 mx-3 ${
              currentStep > 1 ? 'bg-primary-600' : 'bg-gray-300'
            }`} />

            {/* Step 2 */}
            <div className={`flex items-center justify-center w-7 h-7 rounded-full border-2 text-xs font-medium ${
              currentStep === 2
                ? 'border-primary-600 bg-primary-600 text-white'
                : 'border-gray-300 bg-white text-gray-500'
            }`}>
              2
            </div>
            <span className={`ml-2 text-xs font-medium ${
              currentStep === 2 ? 'text-primary-600' : 'text-gray-500'
            }`}>
              Review Details
            </span>
          </div>
        </div>
      </div>

      {/* Error Message */}
      {error && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-4 w-4 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-2">
              <div className="text-sm text-red-700">{error}</div>
            </div>
          </div>
        </div>
      )}

      {/* Prefill Data Notice */}
      {prefillData && currentStep === 1 && (
        <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-md">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-4 w-4 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-2">
              <div className="text-sm text-blue-700">
                Transaction details pre-filled. Upload your receipt to complete the submission.
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Step Content */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
        {currentStep === 1 ? (
          <ReceiptUpload
            onScanComplete={handleScanComplete}
            onError={handleScanError}
          />
        ) : (
          <TransactionDetails
            extractedData={extractedData}
            prefillData={prefillData}
            onSubmit={handleTransactionSubmit}
            onBack={handleBackToUpload}
            isSubmitting={isSubmitting}
          />
        )}
      </div>
    </div>
  );
};

export default TwoStepTransactionForm;